import { useState } from "react";
import { observer } from "mobx-react-lite";
import { AnimatePresence, motion } from "motion/react";
import { store } from "../stores/Store";
import { publicUrl } from "../utils/url";
import CloseIconBig from "../icons/CloseIconBig";
import './MattressBanner.scss';

/**
 * MYB-144: promotional banner shown while the "mattress" step is in view.
 * Visibility is driven by the step's `active` flag, which Controls.jsx sets
 * from an IntersectionObserver on the step headers.
 */
const MattressBanner = observer(() => {
    const [dismissed, setDismissed] = useState(false);
    const isVisible = Boolean(store.getStepByType('mattress')?.active) && !dismissed;

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    className="MattressBanner"
                    initial={{ y: '120%' }}
                    animate={{ y: 0 }}
                    exit={{ y: '120%' }}
                    transition={{ duration: 0.4, ease: 'easeInOut' }}
                >
                    <img
                        className="MattressBanner__image"
                        src={publicUrl('/assets/banner-materace.png')}
                        alt="W zakupie z łóżkiem -10%"
                    />
                    <button
                        type="button"
                        className="MattressBanner__close"
                        aria-label="Zamknij"
                        onClick={() => setDismissed(true)}
                    >
                        <CloseIconBig />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
});
MattressBanner.displayName = 'MattressBanner';
export default MattressBanner;
